/*
  The press office (sections/btf-press-office.liquid): sign in once, then the press kit.
  The server is apps/btf-ai/worker/src/press.js. The sign-in is kept in this browser for 90 days.
*/
(() => {
  const root = document.querySelector('[data-btf-press]');
  if (!root) return;
  const setup = JSON.parse(root.querySelector('[data-po-setup]').textContent);
  const api = String(setup.api || '').replace(/\/+$/, '');
  const KEY = 'btf-press';
  const $ = (s) => root.querySelector(s);
  const form = $('[data-po-form]');
  const kitBox = $('[data-po-kit]');
  const msg = $('[data-po-msg]');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const KINDS = { image: 'Pictures', video: 'Films', logo: 'Logos', pdf: 'Releases' };

  const saved = () => {
    try {
      const s = JSON.parse(localStorage.getItem(KEY) || 'null');
      return s && s.token && s.until > Date.now() ? s : null;
    } catch (e) {
      return null;
    }
  };
  const remember = (s) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...s, until: Date.now() + 89 * 86400000 }));
    } catch (e) {
      /* this visit only */
    }
  };

  const size = (n) => (n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB');
  const meta = (a) =>
    [a.format || (a.kind === 'video' ? 'MP4' : a.kind === 'pdf' ? 'PDF' : 'JPEG'), a.w && a.h ? `${a.w} × ${a.h} px` : '', a.seconds ? Math.round(a.seconds) + ' s' : '', a.size ? size(a.size) : ''].filter(Boolean).join(' · ');

  let kit = null;
  let filter = 'all';

  function draw(session) {
    const items = (kit.assets || []).filter((a) => filter === 'all' || a.kind === filter || a.group === filter);
    $('[data-po-items]').innerHTML = items
      .map(
        (a) => `<li class="btf-po__item">
          <div class="btf-po__thumb${a.kind === 'video' ? ' btf-po__thumb--film' : ''}"><img src="${esc(api)}/press/t/${esc(a.id)}" alt="${esc(a.alt || a.title)}" loading="lazy">${a.kind === 'video' ? '<span class="btf-po__play" aria-hidden="true"></span>' : ''}</div>
          <span class="btf-po__ititle">${esc(a.title)}</span>
          <span class="btf-po__imeta">${esc(meta(a))}</span>
          <a class="btf-btn btf-po__dl" href="${esc(api)}/press/f/${esc(a.id)}?t=${encodeURIComponent(session.token)}" download>Download</a>
        </li>`
      )
      .join('');
  }

  function showKit(session) {
    form.hidden = true;
    if (!kit || !(kit.assets || []).length) {
      $('[data-po-none]').hidden = false;
      return;
    }
    kitBox.hidden = false;
    $('[data-po-hello]').textContent = `Hello ${session.name.split(' ')[0]}, here’s everything in the kit.`;
    const kinds = [...new Set(kit.assets.map((a) => a.kind))];
    const groups = kit.groups || [];
    const opts = [['all', 'Everything'], ...kinds.map((k) => [k, KINDS[k] || k]), ...groups.map((g) => [g.id, g.title])];
    $('[data-po-filters]').innerHTML = opts.length > 2 ? opts.map(([v, t]) => `<button type="button" data-v="${esc(v)}" aria-pressed="${v === filter}">${esc(t)}</button>`).join('') : '';
    draw(session);
  }

  $('[data-po-filters]').addEventListener('click', (e) => {
    const b = e.target.closest('button[data-v]');
    if (!b) return;
    filter = b.dataset.v;
    root.querySelectorAll('[data-po-filters] button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
    draw(saved());
  });

  $('[data-po-out]').addEventListener('click', () => {
    try {
      localStorage.removeItem(KEY);
    } catch (e) {
      /* nothing kept */
    }
    kitBox.hidden = true;
    form.hidden = false;
    form.querySelector('input').focus();
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    msg.hidden = true;
    const f = new FormData(form);
    const body = { name: f.get('name'), email: f.get('email'), publication: f.get('publication'), publish: f.get('publish'), consent: !!f.get('consent'), kind: 'press' };
    const btn = form.querySelector('[type=submit]');
    btn.disabled = true;
    try {
      const r = await fetch(api + '/press/signin', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json().catch(() => ({}));
      if (r.ok && j.token) {
        const s = { token: j.token, name: j.name };
        remember(s);
        showKit(s);
        kitBox.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      } else {
        const missing = { name: 'your name', email: 'an email address', publication: 'your publication or channel' };
        msg.textContent = j.fields ? 'Please add ' + j.fields.map((x) => missing[x] || x).join(', ') + '.' : 'That didn’t go through. Please try again in a moment.';
        msg.hidden = false;
      }
    } catch (err) {
      msg.textContent = 'That didn’t go through. Please check your connection and try again.';
      msg.hidden = false;
    } finally {
      btn.disabled = false;
    }
  });

  fetch(api + '/press/kit')
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null)
    .then((k) => {
      kit = k || { assets: [] };
      const s = saved();
      if (s) showKit(s);
    });
})();
